
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import Avatar from 'vue-avatar'

import MomentsCard from '../components/league/momentsCard.vue'
import configInfo from "../configInfo.js"
import {wxShareConfig} from '../js/common/utils'
import  ApiSetting from "../js/common/api.js"
import  httpServer from "../js/common/http.js"
export default {
props: {



},
components: {
Tab,
TabItem,
Scroller,
Divider,
XSwitch,
Group,
Spinner,
ButtonTab,
ButtonTabItem,
Flexbox,
FlexboxItem,
Avatar,
MomentsCard
},
mounted(){
if(this.eventHub){
this.eventHub.$on('loadMoreShooters', () => {
this.loadMore();
})
this.eventHub.$on('refreshTabShooters', () => {
this.refreshTab();
})
}
this.initTab();


this.shooterInfo = [];
var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
},
beforeRouteLeave (to, from, next) {
if(this.currentPage){

}
next();
},
methods: {
initWxShareConfig:function(){
this.currentPage = window.location.href;
var fullPath = window.location.href;


var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
if (this.leagueBasicInfo.league_logo) {
shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
}
console.log(fullPath)


wxShareConfig({
title: this.leagueBasicInfo.title+'-射手榜',
desc: "来自未来足球赛事系统",
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {
console.log("share success")
}, () => {
console.log("share error")
});
},
getShooterAvatarUrl(avatarId)
{
return this.hagkApi.getImgAsset(avatarId).url+'.jpg';
},
initShooters(data){
if (data && data.length > 0) {
this.shooterStart = data.length;
for (var i = 0; i < data.length; i++) {
data[i].avatarUrl = this.getShooterAvatarUrl(data[i].avatarId)
data[i].useDefault = true;
}
this.shooterInfo = data;
} else {
this.shooterStart = 0;
this.shooterInfo = [];
this.nodataTxt = "暂无数据";
}
},
loadMoreshooterInfo(data) {
if (data && data.length > 0) {
this.shooterStart += data.length;
for (var i = 0; i < data.length; i++) {
data[i].avatarUrl = this.getShooterAvatarUrl(data[i].avatarId)
this.shooterInfo.push(data[i])
}
} else {
this.nodataTxt = "暂无数据";
}
return;
},
loadData(id, start, length, type, successCall, afterCall){
this.nodataTxt = "";
this.hagkHttp(this.hagkApi.getLeagueShooters(id, start, length), {})
.then((res) => {
if (res.status == true) {
successCall(res.result);
if(res.result && res.result.length == 0) {
this.nodataTxt = "暂无数据";
}
}
afterCall();
}, (error) => {
afterCall();
});
},
initTab(){
this.eventHub.$emit("setTabIndex", "shooterList");
this.initWxShareConfig();
var leagueId = parseInt(this.leagueId)
if(this.shooterInfo.length==0) {
this.$vux.loading.show({
text: '加载中...'
})
this.loadData(leagueId, 0, 10, "reserved", this.initShooters, () => {
this.$vux.loading.hide()
})
}
},
refreshTab(){
var leagueId = parseInt(this.leagueId)
this.loadData(leagueId, 0, 10, "reserved", this.initShooters, () => {
this.eventHub.$emit("enablerefreshTab")
})
},
loadMore(){
var leagueId = parseInt(this.leagueId)
this.loadData(leagueId, this.shooterStart, 10, "reserved", this.loadMoreshooterInfo, () => {
this.eventHub.$emit("enableloadMore")
})
}
},
data () {
return {
currentPage:null,
nodataTxt:"",
defaultImageUrl: require('../assets/img/avatar.png'),
defaultImg: 'this.src="' + require('../assets/img/avatar.png') + '"',
shooterStart: 0,
shooterInfo: [],
leagueId:this.$route.query.leagueId,
eventHub:this.$store.getters.getEventHub,
leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
}
}
}



// WEBPACK FOOTER //
// ./src/views/leagueShooters.vue